import { StreamActions } from '@hotwired/turbo'
import { flashNotice, flashError } from './flash'

StreamActions.alert = function () {
  flashError(this.getAttribute('message'))
}

StreamActions.notice = function () {
  flashNotice(this.getAttribute('message'))
}

StreamActions.refresh_bookings = function () {
  console.log('refresh_bookings')
  console.log(this)
  document.getElementById('turbo_modal').innerHTML = ''
  const event = new CustomEvent('refreshBookings')
  window.dispatchEvent(event)
}
